import { ThemeStyles } from '@honda-canada/design-system-react';
import css from '@styled-system/css';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('FormFieldWithLabelWrapper')(({ isFieldExtension }) =>
  css({
    display: 'flex',
    flexDirection: 'column',
    gap: isFieldExtension ? '5px' : '20px',
    marginTop: isFieldExtension ? '-10px' : 0,
    marginBottom: 'xs',
  }),
);

themeStyles.addBaseStyles('Legal')(
  css({
    fontSize: '12px',
    padding: '5px 0',
  }),
);

themeStyles.addBaseStyles('Label')(
  css({
    fontSize: ['14px', '16px'],
  }),
);

themeStyles.addBaseStyles('Error')(
  css({
    fontSize: '12px',
    color: 'red',
  }),
);

themeStyles.addBaseStyles('Title')(
  css({
    textTransform: 'uppercase',
    marginTop: '-20px',
  }),
);

themeStyles.addBaseStyles('FormButton')(
  css({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
);

export default themeStyles;
